export enum MintingState {
    NOT_ACTIVE,
    WHITELIST,
    OPEN_MINT,
    SOLD_OUT
}